import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BasketQtyComponentDef } from '@df/basket/view/basket-qty.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'basket-qty',
    templateUrl: './basket-qty.html',
    standalone: true,
    imports: [TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketQtyComponent extends BasketQtyComponentDef {}
